import { render } from "./VirtualRedTagNotificationMethod.vue?vue&type=template&id=745590c4&scoped=true&ts=true"
import script from "./VirtualRedTagNotificationMethod.vue?vue&type=script&lang=ts"
export * from "./VirtualRedTagNotificationMethod.vue?vue&type=script&lang=ts"

import "./VirtualRedTagNotificationMethod.vue?vue&type=style&index=0&id=745590c4&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745590c4"]])

export default __exports__